module.exports = {
  init : () => {

    const addAriaLabels = () => {
      const facetDateInputs = $('.facetwp-facet-dates').children('input');
      
      facetDateInputs.each(function(i){
        const el = $(this); 

        el.attr('aria-label', el.attr('placeholder'));
      })
    }

    document.addEventListener('facetwp-loaded', addAriaLabels); 
  }
}